import { normalizeTrafficSourceCosts, serializeTrafficSourceCosts } from '../../utils/trafficSourceCostsUtils'
import { map } from '../dispatchers'
import { Type } from '../utils/type'
import { Any } from './Any'
import { Domain, makeDomain } from './Domain'
import { StoreComment, makeStoreComment } from './StoreComment'
export const Store = Type('Store', {
  id: Number,
  name: String,
  url: Any,
  provider: String,
  groups: Array,
  oneTimeEarnings: Array,
  invoices: Array,
  domains: [Domain],
  currency: String,
  language: String,
  locale: String,
  synchronized: Boolean,
  autoupdate: Boolean,
  providerAccountID: Any,
  comments: [StoreComment],
  programID: Any,
  categories: Array,
  hidden: Number,
  topList: Array,
  status: Number,
  showOrders: Number,
  ignoreRule6: Number,
  advertiserUseCPA: Number,
  overridePaymentPercentage: Any,
  logoUrl: Any,
  minimumReturnRate: Any,
  invoiceConfig: Any,
  autoAcceptInstagramStories: Boolean,
  dontCountActions: Boolean,
  paymentType: Any,
  trafficSourceCosts: Array,
  ignoreRemoteEarnings: Boolean,
})

const initInvoiceConfig = (invoiceConfig) => {
  //Logical OR assignment only assign if left hand value is falsy
  invoiceConfig.reference ||= ''
  invoiceConfig.vat_number ||= ''
  invoiceConfig.invoicing_address ||= []
  invoiceConfig.emails ||= []
  invoiceConfig.due_days ||= ''
  return invoiceConfig
}

export const makeStore = ({
  id,
  feed_name: name,
  url,
  feed_provider: provider,
  store_groups: groups,
  one_time_earnings: oneTimeEarnings,
  invoice_payments: invoices,
  urls: domains,
  currency_iso_code: currency,
  language_iso_code: language,
  locale,
  feed: synchronized,
  autoupdate: autoupdate,
  store_provider_account_id: providerAccountID,
  comments: comments,
  program_id: programID,
  store_categories: categories,
  hidden,
  top_list: topList,
  status,
  show_orders: showOrders,
  ignore_rule_6: ignoreRule6,
  advertiser_use_cpa: advertiserUseCPA,
  override_payment_percentage: overridePaymentPercentage,
  logo_url: logoUrl,
  minimum_return_rate: minimumReturnRate,
  invoice_config: invoiceConfig,
  auto_accept_instagram_stories: autoAcceptInstagramStories,
  dont_count_actions_on_invoice: dontCountActions,
  payment_type: paymentType,
  traffic_sources_costs: trafficSourceCosts,
  ignore_remote_earnings: ignoreRemoteEarnings,
}) =>
  Store(
    id,
    name,
    url,
    provider,
    groups,
    oneTimeEarnings,
    invoices,
    map(domains || [], (domain, id) => makeDomain(id, domain)),
    currency,
    language,
    locale,
    !!synchronized,
    !!autoupdate,
    providerAccountID,
    map(comments || [], (comment) => makeStoreComment(comment.id, comment.store_id, comment.key, comment.text, comment.created_at)),
    programID,
    categories,
    hidden,
    topList,
    status,
    showOrders,
    ignoreRule6,
    advertiserUseCPA,
    overridePaymentPercentage ? addingPercentages(overridePaymentPercentage) : 0,
    logoUrl,
    minimumReturnRate,
    initInvoiceConfig(invoiceConfig || {}),
    !!autoAcceptInstagramStories,
    Boolean(dontCountActions),
    paymentType,
    normalizeTrafficSourceCosts(trafficSourceCosts),
    !!ignoreRemoteEarnings,
  )

const serializeInvoiceConfig = (invoiceConfig) => {
  //remove empty values from address
  if (!invoiceConfig) return null
  const address = invoiceConfig.invoicing_address
  invoiceConfig.invoicing_address = address.filter((item) => item)
  return invoiceConfig
}

export const serializeStore = ({ store }) => {
  return {
    id: store.id === -1 ? null : store.id,
    feed_name: store.name,
    url: store.url,
    feed_provider: store.provider,
    store_groups: store.groups,
    one_time_earnings: store.oneTimeEarnings,
    invoice_payments: store.invoices,
    currency_iso_code: store.currency,
    language_iso_code: store.language,
    locale: store.locale,
    autoupdate: store.autoupdate ? 1 : 0,
    store_provider_account_id: store.providerAccountID,
    program_id: store.programID,
    store_categories: store.categories,
    hidden: store.hidden,
    top_list: store.topList,
    status: store.status,
    show_orders: store.showOrders,
    ignore_rule_6: store.ignoreRule6,
    advertiser_use_cpa: store.advertiserUseCPA,
    override_payment_percentage: store.overridePaymentPercentage ? removePercentages(store.overridePaymentPercentage) : null,
    minimum_return_rate: store.minimumReturnRate ? parseFloat(String(store.minimumReturnRate).replace('%', '')) : null,
    invoice_config: serializeInvoiceConfig(store.invoiceConfig),
    auto_accept_instagram_stories: store.autoAcceptInstagramStories ? 1 : 0,
    dont_count_actions_on_invoice: store.dontCountActions,
    payment_type: store.paymentType,
    traffic_sources_costs: serializeTrafficSourceCosts(store.trafficSourceCosts),
    ignore_remote_earnings: store.ignoreRemoteEarnings,
  }
}

export const addingPercentages = (value) => (value ? Math.round(value * 100) + '%' : value)
export const removePercentages = (value) => (value ? String(value).replace('%', '') / 100 : value)
